import React, { useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import { FormGroup, TextField, Checkbox, FormControlLabel, InputLabel, Select, MenuItem, FormControl, Tooltip, IconButton} from "@mui/material"
import HelpCenter from '@mui/icons-material/HelpCenter';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DoneIcon from '@mui/icons-material/Done';
import useAxiosProtect from "../../../../hooks/useAxiosProtect";
const WaterModal = props => {
    const axiosProtect = useAxiosProtect();

    const site_id = parseInt(window.location.href.split('/').slice(-1))
    const utilityType = "water";
    const [year, setYear] = useState('');
    const [month, setMonth] = useState('');
    const [units, setUnits] = useState('m3');
    const [water, setWater] = useState('');
    const [waterCost, setWaterCost] = useState('');
    const [matchCosts, setMatchCosts] = useState(true);
    const [wasteWater, setWasteWater] = useState('');
    const [wasteWaterCost, setWasteWaterCost] = useState('');
    const [invoice, setInvoice] = useState('');
    const [currencies, setCurrencies] = useState('cad');
    const [page, setPage] = useState(1);

    const [yearErr, setYearErr] = useState('');
    const [monthErr, setMonthErr] = useState('');
    const [invoiceErr, setInvoiceErr] = useState('');
    const [waterErr, setWaterErr] = useState('');

    const costTip = 'If N/A or unknown, enter 0.';
    const monthTip = 'Choose the closet month to the metering period and ensure consistency';
    
    useEffect(() => {
            if (props.reading.id) {
                setYear(props.reading.year || '');
                setMonth(props.reading.month || '');
                setUnits(props.reading.water_units || 'm3');
                setWater(props.reading.total_water || '');
                setWaterCost(props.reading.water_cost || '');
                setWasteWater(props.reading.total_wastewater || '');
                setWasteWaterCost(props.reading.wastewater_cost || '');
                setInvoice(props.reading.total_bill_cost || '');
                setCurrencies(props.reading.currency || 'cad');
            } 
     },[props.reading]);

    useEffect(() => {
        if (matchCosts) {
            setWasteWater(water);
        }
    }, [water, matchCosts]);

    const handleYear = (event) => {
        setYear(event.target.value );
    };
    const handleMonth = (event) => {
        setMonth(event.target.value );
    };
    const handleWater = (event) => {
        setWater(event.target.value );
    };
    const handleWasteWater = (event) => {
        setWasteWater(event.target.value );
    };
    const handleInvoice = (event) => {
        setInvoice(event.target.value );
    };
    const handleUnits = (event) => {
        setUnits(event.target.value );
      };

    const handleCurrencies = (event) => {
        setCurrencies(event.target.value );
    };

    const handleWaterCostChange = (event) => setWaterCost(event.target.value);
    const handleWasteWaterCostChange = (event) => setWasteWaterCost(event.target.value);
    const handleCheckboxChange = (event) => setMatchCosts(event.target.checked);

    const createOrUpdateUtilityReading = async () => {
        try {
            const payload = {
                site_id: site_id,
                units: units,
                total_water: parseFloat(water),
                water_cost: parseFloat(waterCost),
                total_wastewater: parseFloat(wasteWater),
                wastewater_cost: parseFloat(wasteWaterCost),
                total_bill_cost: parseFloat(invoice),
                month: parseInt(month),
                year: parseInt(year),
                start_date: "2025-04-01",
                end_date: "2025-05-02",
            };
            console.log(payload)
            console.log(props.reading)
            
            let response;
            console.log(utilityType)

            if (props.reading.id) {
                console.log(props.reading.id)
                response = await axiosProtect.put(`/u/utilities?utilityType=${utilityType}&id=${props.reading.id}`, payload);
                
            }else {
                response = await axiosProtect.post(`/u/utilities?utilityType=${utilityType}`, payload);
                props.onReadingCreated(response.data);
            }

            console.log("Success:", response.data);

            props.onClose(); // Close the modal on success
    
        } catch (err) {
            console.error("Error:", err.response?.data || err.message);
        }
    };

    const validateInitPage = () => {
        let isValid = true;
        if (year === '') {
            setYearErr('Invalid');
            isValid = false;
        }

        if (month === '') {
            setMonthErr('Invalid');
            isValid = false;
        }

        if (invoice === '') {
            setInvoiceErr('Invalid');
            isValid = false;
        }
        return isValid;
    }

    const validateSecondPage = () => {
        let isValid = true;
        if (water === '') {
            setWaterErr('Invalid');
            isValid = false;
        }
        return isValid;
}

    const incrementPage = () => {
        if(page === 1 && validateInitPage()){
            setPage(page + 1);

        }else if(page === 2 && validateSecondPage()){
            createOrUpdateUtilityReading()

        }
    }
    
    return (
        <Modal 
            show={true} 
            onHide={props.onClose} 
            backdrop="static"
            centered
            className="opp-modal-root"
            backdropClassName="opp-modal-backdrop"
            dialogClassName="opp-modal-cw"
        >
            <Modal.Header closeButton>
                <Modal.Title>{props.reading.id ? 'Update Water Utility Readings' : 'Add Water Utility Readings'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

            {page === 1 &&
                <>
                
            <TextField 
                fullWidth id="outlined-basic" 
                label="Year" 
                variant="outlined" 
                type="number" 
                value={year} 
                onChange={handleYear} 
                error={yearErr !== ''}
                helperText={yearErr}
                style={{ width: '100%', marginBottom: '1.25vh' }} />

            <div className="field-row-full-mb">
                <FormControl fullWidth style={{ width: '100%', marginBottom: '1.25vh' }}>
                    <InputLabel id="demo-simple-select-label">Month</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        defaultValue="m3"
                        label="Month"
                        error={monthErr !== ''}
                        helperText={monthErr}
                        value={month}
                        onChange={handleMonth}
                        MenuProps={{ disablePortal: true }}
                    >
                        <MenuItem value={1}>January</MenuItem>
                        <MenuItem value={2}>February</MenuItem>
                        <MenuItem value={3}>March</MenuItem>
                        <MenuItem value={4}>April</MenuItem>
                        <MenuItem value={5}>May</MenuItem>
                        <MenuItem value={6}>June</MenuItem>
                        <MenuItem value={7}>July</MenuItem>
                        <MenuItem value={8}>August</MenuItem>
                        <MenuItem value={9}>September</MenuItem>
                        <MenuItem value={10}>October</MenuItem>
                        <MenuItem value={11}>November</MenuItem>
                        <MenuItem value={12}>December</MenuItem>
                    </Select>
                    </FormControl>
                    <Tooltip title={monthTip} className="field-tooltip-col" slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className="help-icon-btn">
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div> 
                
                <div className="field-row-full-mb">
                <TextField 
                    fullWidth 
                    id="outlined-basic" 
                    label="Total Invoice Cost ($)" 
                    type="number" 
                    variant="outlined" 
                    error={invoiceErr !== ''}
                    helperText={invoiceErr}
                    value={invoice} 
                    onChange={handleInvoice} 
                    style={{ width: '100%', marginBottom: '1.25vh' }} />

                    <Tooltip title={costTip} className="field-tooltip-col" slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className="help-icon-btn">
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div>
                <FormControl fullWidth style={{ width: '100%', marginBottom: '1.25vh' }}>
                    <InputLabel id="demo-simple-select-label">Currency</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        defaultValue="cad"
                        label="Currency"
                        value={currencies}
                        onChange={handleCurrencies}
                        MenuProps={{ disablePortal: true }}
                    >
                    <MenuItem value="cad">CAD</MenuItem>
                    <MenuItem value="usd">USD</MenuItem>
                    <MenuItem value="mex">Mex$</MenuItem>
                    <MenuItem value="gdp">GBP</MenuItem>
                    <MenuItem value="eur">EUR</MenuItem>
                    </Select>
                </FormControl>
                

                </>
            }
            {page===2 &&
            <>
            <FormControl fullWidth style={{ width: '100%', marginBottom: '1.25vh' }}>
                    <InputLabel id="demo-simple-select-label">Water Units</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        defaultValue="m3"
                        label="Water Units"
                        value={units}
                        onChange={handleUnits}
                        MenuProps={{ disablePortal: true }}
                    >
                        <MenuItem value="m3">m<sup>3</sup></MenuItem>
                        <MenuItem value="usg">USG</MenuItem>
                        <MenuItem value="mcf">MCF</MenuItem>
                        <MenuItem value="ccf">CCF</MenuItem>
                        <MenuItem value="acf">acre-feet</MenuItem>
                        <MenuItem value="l">L</MenuItem>
                    </Select>
                </FormControl>
                <div className="field-row-full-mb">
                <TextField 
                    fullWidth 
                    id="outlined-basic" 
                    label="Water Consumed (m3)" 
                    variant="outlined" 
                    type="number" 
                    error={waterErr !== ''}
                    helperText={waterErr}
                    value={water} 
                    onChange={handleWater} 
                    style={{ width: '100%', marginBottom: '1.25vh' }} />

                    <Tooltip title={costTip} className="field-tooltip-col" slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className="help-icon-btn">
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div> 
                <FormGroup>
                    <FormControlLabel control={<Checkbox checked={matchCosts} onChange={handleCheckboxChange} />} label="Match Total wastewater with Total water consumed" />
                </FormGroup>
                
                <div className="field-row-full-mb">
                <TextField 
                    fullWidth 
                    id="outlined-basic" 
                    label="Total Water Cost ($)" 
                    variant="outlined" 
                    value={waterCost} 
                    onChange={handleWaterCostChange}
                    className="w-full" />

                    <Tooltip title={costTip} className="field-tooltip-col" slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className="help-icon-btn">
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div> 
                <div className="field-row-full-mb">
                <TextField 
                    fullWidth id="outlined-basic" 
                    label="Total Wastewater" 
                    variant="outlined" 
                    type="number" 
                    value={wasteWater} 
                    onChange={handleWasteWater}
                    disabled={matchCosts} style={{ width: '100%', marginBottom: '1.25vh' }} />

                    <Tooltip title={costTip} className="field-tooltip-col" slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className="help-icon-btn">
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div> 
                
                <div className="field-row-full-mb">
                <TextField 
                    fullWidth id="outlined-basic" 
                    label="Total Wastewater Cost ($)" 
                    variant="outlined" 
                    type="number" 
                    value={wasteWaterCost} 
                    onChange={handleWasteWaterCostChange} 
                    style={{ width: '100%', marginBottom: '1.25vh' }} />
                    <Tooltip title={costTip} className="field-tooltip-col" slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className="help-icon-btn">
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div> 
                </>}
            </Modal.Body>
            <Modal.Footer>

                <div className="field-row-full">
                    {page > 1 && <IconButton aria-label="site-create-back" onClick={() => setPage(page - 1)}>
                        <ArrowBackIcon />
                    </IconButton>}

                    <div className="field-spacer-lg"></div>

                    <IconButton aria-label="site-create-next" onClick={() => incrementPage()}>
                        {page < 2 ? <ArrowForwardIcon /> :<DoneIcon /> }
                    </IconButton>
                </div>
                
            </Modal.Footer>
        </Modal>
    )
}

export default WaterModal;